<script setup lang="ts">
import { ListChecks, Search, X } from '@lucide/vue'
import { computed } from 'vue'
import { Button, Field, Input, Label } from 'catalyst-vue'
import { useLibraryEntriesStore } from '../../stores/library-entries'
import { useControlSize } from '../../lib/library-layout'
import CategoryFilterPicker from './category-filter-picker.vue'
import LibraryDisplayControls from './library-display-controls.vue'

const store = useLibraryEntriesStore()
const controlSize = useControlSize()
const filterOpen = defineModel<boolean>('filterOpen', { default: false })
// 搜尋與分類只有一份，兩邊的來源吃同一組條件。
const query = computed({ get: () => store.query, set: value => { store.query = value } })
const categoryIds = computed({ get: () => store.selectedCategories, set: value => { store.selectedCategories = value } })
const ready = computed(() => store.ready)
</script>

<template>
  <div class="library-toolbar">
    <div class="library-toolbar-row">
      <Field class="library-search">
        <Label class="sr-only">搜尋書名或作者</Label>
        <Input v-model="query" type="search" :size="controlSize" placeholder="搜尋書名或作者" :disabled="!ready"><template #prefix><Search :size="18" aria-hidden="true" /></template></Input>
      </Field>
      <CategoryFilterPicker v-model:open="filterOpen" />
      <Button v-if="query || categoryIds.length" plain :size="controlSize" class="clear-filters" @click="store.clearFilters()"><X :size="15" aria-hidden="true" />清除篩選</Button>
      <span class="library-toolbar-gap" />
      <LibraryDisplayControls />
      <Button
        v-if="!store.selectionMode"
        outline
        :size="controlSize"
        class="selection-mode-toggle"
        :disabled="!ready"
        @click="store.enterSelectionMode()"
      ><ListChecks :size="15" aria-hidden="true" />多選</Button>
    </div>
  </div>
</template>
